export default __webpack_public_path__ + "static/course-certificate-757cf074f17e14946e55ae0098059a63.png";